import {HeaderDropdownService} from "../../global/header/header-dropdown-service";
import MobileNavModule from "../../global/header/mobile-nav-module";
import {CourseMenuLoader} from "../../global/header/course-menu-loader";

export default class SprintHeader {
    constructor() {
        this.$root = document.getElementById('siteHeader');
        this.$mobileNavMenuHeader = document.querySelector('.mobile-nav-menu .mobile-nav-menu_header');
        this.$mobileNavMenuTrigger = document.getElementById('mobileNavMenu');
        this.$sectionsContainer = document.getElementById('mobileNavMenuSections');

        this.courseMenuLoader = new CourseMenuLoader(true);

        this.initHeaderDropdownService();
        this.initMobileNavModule();
        this.addSprintMenuOpenListener();
    }

    initHeaderDropdownService() {
        const dropdownService = new HeaderDropdownService(this.$root);
        this.courseMenuLoader.loadDesktopCourseMenu(dropdownService);
    }

    initMobileNavModule() {
        const mobileNavModule = new MobileNavModule(this.$mobileNavMenuTrigger);
        this.courseMenuLoader.loadMobileCourseMenu(mobileNavModule);
    }

    addSprintMenuOpenListener() {
        document.getElementById('sprintsMenuMobileTrigger')
            .addEventListener('click', () => {
                this.$sectionsContainer.dataset.active = 'sprints-menu';
                this.$mobileNavMenuHeader.classList.add('-back');
            });
    }
}